import React from "react";

import "./index.css";

export default function UseTerms() {
  return (
    <>
      <section className="terms">
        <p className="terms-title">
          <span>Termos e Condi&ccedil;&otilde;es Sindicante Digital. </span>
        </p>
        <p>
          <span>
            Leia os termos e condi&ccedil;&otilde;es com aten&ccedil;&atilde;o.
            Ao realizar o seu cadastro voc&ecirc; Est&aacute; de Acordo com as
            Condi&ccedil;&otilde;es e Termos do Sindicante Digital. Agora, se
            voc&ecirc; n&atilde;o concordar com os Termos, impedir&aacute; que
            voc&ecirc; embarque na transforma&ccedil;&atilde;o digital da
            Sindic&acirc;ncia.
          </span>
        </p>
        <h4 className="terms-section-title">1. O que oferecemos:</h4>
        <section className="terms-section">
          <p>
            <span>
              1. Este termos &eacute; aplicado para regular sua
              utiliza&ccedil;&atilde;o ao que &eacute; oferecido pelo Sindicante
              Digital ao seus usu&aacute;rios - Seguradoras, Reguladoras de
              Sinistro, Peritos e Avaliadores de Seguros - conduzir as etapas
              dos Processos via online, desde o registro at&eacute; a
              conclus&atilde;o de processos fornecidos pelas Seguradoras,
              Reguladoras de Sinistro, Peritos e/ou Avaliadores de Seguros
              online.
            </span>
          </p>
          <p>
            <span>
              1.1 O Sindicante Digital oferece, portanto, o servi&ccedil;o de
              unir, atrav&eacute;s do nosso web app, os usu&aacute;rios -
              SEguradoras, Reguladoras de Sinistro, Peritos e Avaliadores de
              Seguros nele cadastrados, possibilitando que:
            </span>
          </p>
          <p>
            <span>
              1.2 &nbsp;As Seguradoras: Realizem o cadastro dos processos e os
              designa &agrave;s Empresas Reguladoras de Sinistro tamb&eacute;m
              cadastradas e acompanhem o progresso/status atrav&eacute;s dos
              pain&eacute;is de indicadores (dashboards);
            </span>
          </p>
          <p>
            <span>
              1.2 As Reguladoras de Sinistro: Recebem os processos &agrave; elas
              designados pela Seguradora e os designa para os Peritos e
              Avaliadores aqui cadastrados;
            </span>
          </p>
          <p>
            <span>
              1.2.1 As Reguladoras de Sinistro: Realizam o cadastro dos
              processos independente de ter recebido pela Seguradora no
              Sindicante Digital e designa para os Peritos e Avaliadores aqui
              cadastrados;
            </span>
          </p>
          <p>
            <span>
              1.3 Os Peritos Avaliadores: Recebem os processos &agrave; eles
              designados e conduzem suas etapas online no Sindicante Digital.
            </span>
          </p>
          <p>
            <span>
              1.3.1 Os Peritos e Avaliadores: Cadastram seus processos e
              conduzem suas etapas online no Sindicante Digital e, ao concluir,
              poder&aacute; compartilhar o processo atrav&eacute;s de doc.
            </span>
          </p>
          <p>
            <span>
              1.4 Fica esclarecido aos usu&aacute;rios - que est&atilde;o ciente
              e concordam com esse termo - que o Sindicante Digital oferece o
              Servi&ccedil;o apenas de intermedia&ccedil;&atilde;o de
              gerenciamento dos processos, n&atilde;o abarcando as
              responsabilidades de registrar e designar processos aos
              usu&aacute;rios. Sendo essas responsabilidades - registrar,
              designar, conduzir, concluir e compartilhar - integral dos
              usu&aacute;rios que dever&atilde;o direcionar as tratativas em
              rela&ccedil;&atilde;o ao andamento e qualquer
              reclama&ccedil;&atilde;o decorrente de malfeitos,
              inexecu&ccedil;&atilde;o, qualidade, cumprimento de prazo e
              regularidade dos processos.
            </span>
          </p>
        </section>
        <h4 className="terms-section-title">2. Ao se cadastrar:</h4>
        <section className="terms-section">
          <p>
            <span>
              2.1 Os usu&aacute;rios, para utilizar os servi&ccedil;os acima
              descritos, dever&aacute; ter capacidade jur&iacute;dica para atos
              civis e dever&aacute;, preencher e anexar as
              informa&ccedil;&otilde;es, necess&aacute;rias e exigidas no
              cadastro, se responsabilizando (c&iacute;vel e criminal) pela
              exatid&atilde;o e veracidade das informa&ccedil;&otilde;es
              fornecidas no cadastro, que ser&aacute; verificada pelo Sindicante
              Digital.
            </span>
          </p>
          <p>
            <span>
              2.1.1 Em caso de informa&ccedil;&otilde;es incorretas, seja por
              digita&ccedil;&atilde;o ou inver&iacute;dicas, identificadas e
              n&atilde;o revisadas a pedido do Sindicante Digital pelo
              usu&aacute;rio, ou o reenvio de documentos que comprovem a
              corre&ccedil;&atilde;o do seu cadastro, o Sindicante Digital se
              reserva o direito de n&atilde;o concluir o cadastro ou, ainda
              bloquear o cadastro j&aacute; existente, impedindo o
              usu&aacute;rio de utilizar os servi&ccedil;os oferecidos pelo
              Sindicante Digital, at&eacute; que a situa&ccedil;&atilde;o seja
              regularizada e comprovada, dentro dos crit&eacute;rios do
              Sindicante digital. Caso o Sindicante digital, em sua
              avalia&ccedil;&atilde;o de cadastro dos usu&aacute;rios, detecte
              qualquer anomalia ou agravamento de risco em sua plataforma
              online, que possa agravar o risco dos demais usu&aacute;rios
              cadastros, fica reservado direito de impedir o cadastro ou
              cancelar cadastro j&aacute; existente. Tamb&eacute;m ser&aacute;
              negado ou cancelado cadastro, caso seja identificado que o
              usu&aacute;rio n&atilde;o tenha cumprido as regras aqui descritas
              no presente termo.
            </span>
          </p>
          <p>
            <span>
              2.2 Ap&oacute;s o cadastro do usu&aacute;rio, efetuado com
              sucesso, ter&aacute; acesso aos servi&ccedil;os oferecidos, e aqui
              descritos pelo Sindicante Digital. Ficando sob responsabilidade,
              &uacute;nica e exclusiva, de garantir a n&atilde;o
              divulga&ccedil;&atilde;o do seu Login e Senha a terceiros, se
              responsabilizando tamb&eacute;m pelo gerenciamento dos processos
              registrados ou designados ao seu perfil - cadastro/titularidade.
            </span>
          </p>
        </section>
        <h4 className="terms-section-title">
          3. Responsabilidades e Obriga&ccedil;&otilde;es do Usu&aacute;rio
        </h4>

        <section className="terms-section">
          <p>
            <span>
              3.1 Ap&oacute;s cadastro do usu&aacute;rio efetuado com sucesso,
              &eacute; de sua responsabilidade n&atilde;o divulgar ou
              compartilhar a terceiros seu login e senha de acesso, nem permitir
              o uso de tais informa&ccedil;&otilde;es por terceiros,
              responsabilizando-se integralmente pelas consequ&ecirc;ncias do
              uso de login e senha do seu perfil e titularidade -
              cadastro/titularidade.
            </span>
          </p>
          <p>
            <span>
              3.2 &Eacute; responsabilidade obrigat&oacute;ria do Usu&aacute;rio
              garantir o fornecimento das informa&ccedil;&otilde;es cadastrais
              totalmente ver&iacute;dicas e exatas, ficando ciente e
              responsabilizando-se exclusiva e integralmente por todo
              conte&uacute;do por si informado no cadastro e os mantendo
              atualizado e confirmado, sempre que solicitado pelo Sindicante
              Digital.{" "}
            </span>
          </p>
          <p>
            <span>
              3.3 O usu&aacute;rio obriga-se a pagar integralmente pela
              transa&ccedil;&atilde;o dos processos registrados e
              conclu&iacute;dos de acordo com o seu perfil de
              utiliza&ccedil;&atilde;o.
            </span>
          </p>
          <p>
            <span>
              &nbsp;3.4 O usu&aacute;rio concorda com o uso das
              informa&ccedil;&otilde;es de avalia&ccedil;&otilde;es e feedbacks
              dos processos conduzidos e finalizados no Sindicante Digital.
            </span>
          </p>
        </section>
        <h4 className="terms-section-title">
          4. Responsabilidade e Obriga&ccedil;&otilde;es Sindicante Digital:
        </h4>
        <section className="terms-section">
          <p>
            <span>
              4.1 Garantir e disponibilizar no site Sindicante Digital todas as
              etapas de registro, condu&ccedil;&atilde;o, conclus&atilde;o e
              acompanhamento dos processos, permitindo que os usu&aacute;rios
              devidamente cadastrados.
            </span>
          </p>
          <p>
            <span>
              4.2 Garantir privacidade, por meio de armazenamento em servidores
              ou quaisquer outro meio magn&eacute;tico de alta seguran&ccedil;a,
              a confidencialidade de todas as informa&ccedil;&otilde;es e
              cadastro relativos aos Usu&aacute;rios.{" "}
            </span>
          </p>
        </section>

        <h4 className="terms-section-title">5. Modifica&ccedil;&otilde;es do termo:</h4>
        <section className="terms-section">
          <p>
            <span>
              5.1 Este termo e condi&ccedil;&otilde;es poder&aacute;, a qualquer
              momento, por&eacute;m com notifica&ccedil;&atilde;o ao
              usu&aacute;rio, ter seu conte&uacute;do, parte dele, modificado
              para adequa&ccedil;&otilde;es e inser&ccedil;&otilde;es, tudo com
              vistas ao aprimoramento dos servi&ccedil;os oferecidos e
              disponibilizados.
            </span>
          </p>
          <p>
            <span>
              5.2 As condi&ccedil;&otilde;es modificadas e/ou alteradas, seja
              ela acrescida ou retirada, entrar&aacute; em vig&ecirc;ncia assim
              que veiculada no site Sindicante Digital, dando ao usu&aacute;rio
              a oportunidade de manifesta&ccedil;&atilde;o, seja ela por
              oposi&ccedil;&atilde;o ou apenas considera&ccedil;&atilde;o a
              qualquer termo modificado. Desde que o fa&ccedil;a por escrito nos
              canais de comunica&ccedil;&atilde;o do Sindicante Digital. Podendo
              ser cancelado seu cadastro, caso assim queira.
            </span>
          </p>
        </section>

        <h4 className="terms-section-title">6. Canais de comunica&ccedil;&atilde;o:</h4>
        <section className="terms-section">
          <p>
            <span>
              6.1 Os canais de comunica&ccedil;&atilde;o do Sindicante Digital
              est&atilde;o dispon&iacute;veis no seu site e para os
              usu&aacute;rios cadastrados, direcionado ao chat online, sendo que
              o usu&aacute;rio responsabiliza-se em manter seu cadastro
              atualizado, incluindo seu endere&ccedil;o eletr&ocirc;nico, do
              qual se se far&atilde;o as comunica&ccedil;&otilde;es dirigidas
              pelo Sindicante Digital.
            </span>
          </p>
        </section>

        <h4 className="terms-section-title">7. Aceite do termo de uso</h4>

        <section className="terms-section">
          <p>
            <span>
              7.1 O usu&aacute;rio declara ter lido, entendido e que aceita
              todas as regras, condi&ccedil;&otilde;es, responsabilidades e
              obriga&ccedil;&otilde;es estabelecidas neste termo;
            </span>
          </p>
        </section>

        <h4 className="terms-section-title">8. Foro de elei&ccedil;&atilde;o:</h4>
        <section className="terms-section">
          <p>
            <span>
              8.1 &nbsp;As partes elegem como competente para dirimir eventuais
              controv&eacute;rsias que venham a surgir da
              interpreta&ccedil;&atilde;o e do cumprimento do presente termo o
              foro da comarca de S&atilde;o Paulo - SP.
            </span>
          </p>
        </section>

        <section className="terms-section">
          <p className="terms-update">
            <span>&Uacute;ltima atualiza&ccedil;&atilde;o 23/11/2020</span>
          </p>
        </section>
      </section>
    </>
  );
}
